import type { InputHTMLAttributes } from 'react';

interface DatePickerProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  helperText?: string;
  error?: string;
}

export default function DatePicker({ label, helperText, error, className = '', id, style, ...props }: DatePickerProps) {
  const inputId = id || label?.toLowerCase().replace(/\s/g, '-');
  return (
    <div>
      {label && <label htmlFor={inputId} className="form-label">{label}</label>}
      <input
        type="date"
        id={inputId}
        className={`form-input ${className}`}
        style={error ? { borderColor: 'var(--red)', ...style } : style}
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined}
        {...props}
      />
      {helperText && !error && <p id={`${inputId}-helper`} className="form-helper">{helperText}</p>}
      {error && <p id={`${inputId}-error`} className="form-helper form-helper-error" role="alert">{error}</p>}
    </div>
  );
}
